import { Chip, tooltipClasses } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { createElement } from "react";
import { TbUserBolt, TbUserHexagon } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { softColors } from "@/constants/colors";
import { PatientTypeItem, patientTypes } from "@/constants/patientTypeStatuses";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";
import { PassengersGroupTableRow } from "@/types/tasks.types";

const vipTypes = ["VIP-Angebot", "Angebot", "Influencer"];
function PatientTypeCell({ value }: { value: string }) {
    const status: PatientTypeItem = patientTypes.find((item) => item.values.includes(value)) || {
        label: value,
        tooltip: {
            title: value,
            description: "",
        },
        ...softColors.brown,
        component: () => TbUserBolt,
        values: [""],
    };
    return (
        <div className="flex items-center  h-full">
            {
                <NoMaxWidthTooltip
                    arrow
                    sx={{
                        [`& .${tooltipClasses.tooltip}`]: {
                            backgroundColor: "white",
                            border: "none",
                            padding: "0px !important",
                            fontSize: 11,
                            maxWidth: "240px !important",
                        },
                    }}
                    title={<HotelStatusTooltip status={status} />}
                >
                    <Chip
                        sx={{
                            backgroundColor: status.bg,
                            color: status.text,
                            fontWeight: 500,
                            fontSize: "12px !important",
                        }}
                        icon={createElement(status.component(), {
                            fontSize: 14,
                            color: status.text,
                        })}
                        label={status.label}
                    />
                </NoMaxWidthTooltip>
            }
        </div>
    );
}

const PatientTypeColumn = ({ t }: { t: TFunction }): GridColDef<PassengersGroupTableRow> => {
    return {
        headerName: t("patientType"),
        field: "patientType",
        cellClassName: "!px-1",
        minWidth: 120,
        sortable: true,
        disableColumnMenu: true,
        valueGetter: (_, row) => (vipTypes.includes(row.vip || "") ? "Influencer" : "normal"),
        renderHeader: (params) => <TableHeader Component={TbUserHexagon} title={params.colDef.headerName!} />,
        renderCell: ({ value }) => <PatientTypeCell value={value} />,
    };
};

export default PatientTypeColumn;
